// Libs
import React, { useEffect, useState } from 'react';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { TipoOptions } from '@app/api/api';
import { IDiretoria, getAllOrganograma } from '@app/api/organograma';
import {
    CrfAreaExecutiveSummaryResult,
    CrfFiltroPesquisaAreaExecutiveSummaryFromProps,
    getCrfAreaExecutiveSummary
} from '@app/api/crf/areaExecutiveSummary';

interface FiltroPesquisaAreaExecutiveSummaryProps {
    tratarValoreDashboardAreaExecutiveSummary: (areaExecutiveSummary: CrfAreaExecutiveSummaryResult) => void;
    fechamentoId?: string;
    telaInicial: boolean;
}



const FiltroPesquisaAreaExecutiveSummary = ({ tratarValoreDashboardAreaExecutiveSummary, fechamentoId, telaInicial }: FiltroPesquisaAreaExecutiveSummaryProps) => {

    const [ogranograma, setOrganograma] = useState<Array<IDiretoria>>();
    const [departamento, setDepartamento] = useState<Array<TipoOptions>>();
    const [area, setArea] = useState<Array<TipoOptions>>();
    const [diretoria, setDiretoria] = useState<Array<TipoOptions>>();
    const [form, setForm] = useState<CrfFiltroPesquisaAreaExecutiveSummaryFromProps>();


    useEffect(() => {
        hasGetAllOrganograma();
    }, []);

    const hasGetAllOrganograma = () => {

        getAllOrganograma().then((organograma) => {
            setOrganograma(organograma);
            const diretorias = Array<TipoOptions>();
            if (organograma && organograma.length) {
                organograma.forEach((diretoria) => {
                    let texto = `${diretoria.sigla} - ${diretoria.nome}`;
                    const diretoriaTipoOption = { value: diretoria.id, text: texto } as TipoOptions;
                    diretorias.push(diretoriaTipoOption);
                });
            }
            setDiretoria(diretorias);
        });
    }

    const hasGetAreaAndDepartamentoByDiretoriaId = (diretoriaId: string) => {

        if (diretoriaId && ogranograma && ogranograma.length) {
            setForm({ diretoriaId: diretoriaId, departamentoId: undefined, areaId: undefined });
            const diretoriaResult = ogranograma.filter(c => c.id == diretoriaId);

            const areaDiretoria = Array<TipoOptions>();
            const departamentoDiretoria = Array<TipoOptions>();

            const areaDiretoriaResult = diretoriaResult[0].areas;
            const departamentoDiretoriaResult = diretoriaResult[0].departamentos;

            if (diretoriaResult) {

                if (areaDiretoriaResult) {
                    areaDiretoriaResult.forEach((area) => {
                        let texto = `${area.sigla} - ${area.nome}`;
                        const areaTipoOption = { value: area.id, text: texto } as TipoOptions;
                        areaDiretoria.push(areaTipoOption);
                    });
                }

                if (departamentoDiretoriaResult) {
                    departamentoDiretoriaResult.forEach((departamento) => {
                        let texto = `${departamento.sigla} - ${departamento.nome}`;
                        const departamentoTipoOption = { value: departamento.id, text: texto } as TipoOptions;

                        departamentoDiretoria.push(departamentoTipoOption);
                    });
                }

            }
            setDepartamento(departamentoDiretoria);
            setArea(areaDiretoria);
        } else {
            if (diretoriaId === undefined) {
                setForm({ diretoriaId: undefined, areaId: undefined, departamentoId: undefined });
                setDepartamento([]);
                setArea([]);
            }
        }
    }

    const hasGetDepartamentoByAreaId = (areaId: string) => {

        if (areaId && ogranograma && ogranograma.length && form && form.diretoriaId) {
            setForm({ ...form, areaId: areaId, departamentoId: undefined });
            const departamentoDiretoria = Array<TipoOptions>();
            const diretoriaResult = ogranograma.filter(c => c.id == form.diretoriaId);
            const areaResult = diretoriaResult[0].areas.filter(c => c.id == areaId);

            if (areaResult && areaResult.length) {
                if (areaResult[0].departamentos) {
                    areaResult[0].departamentos.forEach((departamento) => {
                        let texto = `${departamento.sigla} - ${departamento.nome}`;
                        const departamentoTipoOption = { value: departamento.id, text: texto } as TipoOptions;

                        departamentoDiretoria.push(departamentoTipoOption);
                    });
                }
            }
            setDepartamento(departamentoDiretoria);
        } else {
            if (areaId === undefined) {
                setForm({ ...form, departamentoId: undefined, areaId: undefined });
                setDepartamento([]);
            }
        }
    }

    return (
        <ui.MasterDetailForm
            key="filtroPesquisa"
            initialValues={form}
            onSubmit={(values: CrfFiltroPesquisaAreaExecutiveSummaryFromProps) => {
                values['fechamentoId'] = fechamentoId;
                values['telaInicial'] = telaInicial;

                getCrfAreaExecutiveSummary(values).then((data) => {
                    if (data)
                        tratarValoreDashboardAreaExecutiveSummary(data);
                });
            }}>

            <ui.FilterWidget
                title="FILTROS DE PESQUISA"
                actions={[
                    <ui.FormSubmitButton icon={'commons-search'}>Pesquisar</ui.FormSubmitButton>
                ]}>

                <div className="ant-row">

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item: any) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        name="diretoriaId"
                        id="diretoriaId"
                        label="Diretoria"
                        options={diretoria}
                        span={3}
                        allowClear
                        onChange={(diretoriaId) => {
                            const diretoriaSelect = diretoriaId as string;
                            const formDiretoria: any = { ...form, diretoriaId: diretoriaSelect };
                            setForm(formDiretoria);
                            hasGetAreaAndDepartamentoByDiretoriaId(diretoriaSelect);
                        }}
                    />

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item: any) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        name="areaId"
                        id="areaId"
                        label="Área"
                        options={area}
                        span={3}
                        allowClear
                        onChange={(areaId) => {
                            const areaIdSelect = areaId as string;
                            const formArea: any = { ...form, areaId: areaIdSelect };
                            setForm(formArea);
                            hasGetDepartamentoByAreaId(areaId as string);
                        }}
                    />

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item: any) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        name="departamentoId"
                        id="departamentoId"
                        label="Departamento"
                        options={departamento}
                        span={3}
                        allowClear
                        onChange={(departamentoId) => {
                            const departamentoIdSelect = departamentoId as string;
                            const formDepartamento: any = { ...form, departamentoId: departamentoIdSelect };
                            setForm(formDepartamento);
                        }}
                    />

                    <ui.FormSelect
                        name="fechamentoMina"
                        id="fechamentoMina"
                        label="Categoria"
                        options={[
                            { value: true, text: 'Fechamento de Mina' },
                            { value: false, text: 'Conta Resultado' }
                        ]}
                        span={3}
                        allowClear
                        onChange={(fechamentoMina) => {
                            const fechamentoMinaSelect = fechamentoMina as string;
                            const formChange: any = { ...form, fechamentoMina: fechamentoMinaSelect };
                            setForm(formChange);
                        }}
                    />
                </div>
            </ui.FilterWidget>

        </ui.MasterDetailForm >
    );
};

export default FiltroPesquisaAreaExecutiveSummary;




